import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const DiscordIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
  </svg>
);

const SteamIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M11.979 0C5.678 0 .511 4.86.022 11.037l6.432 2.658c.545-.371 1.203-.59 1.912-.59.063 0 .125.004.188.006l2.861-4.142V8.91c0-2.495 2.028-4.524 4.524-4.524 2.494 0 4.524 2.031 4.524 4.527s-2.03 4.525-4.524 4.525h-.105l-4.076 2.911c0 .052.004.105.004.159 0 1.875-1.515 3.396-3.39 3.396-1.635 0-3.016-1.173-3.331-2.727L.436 15.27C1.862 20.307 6.486 24 11.979 24c6.627 0 12.001-5.373 12.001-12S18.606 0 11.979 0zM7.54 18.21l-1.473-.61c.262.543.714.999 1.314 1.25 1.297.539 2.793-.076 3.332-1.375.263-.63.264-1.319.005-1.949s-.75-1.121-1.377-1.384c-.624-.26-1.29-.249-1.878-.03l1.523.63c.956.4 1.409 1.49 1.013 2.445-.397.957-1.49 1.41-2.45 1.023zm8.8-9.24c0-1.664-1.353-3.016-3.016-3.016-1.661 0-3.014 1.353-3.014 3.016 0 1.665 1.353 3.018 3.014 3.018 1.663 0 3.016-1.354 3.016-3.018z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);

const GamepadIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
    <line x1="6" y1="12" x2="10" y2="12" />
    <line x1="8" y1="10" x2="8" y2="14" />
    <circle cx="15" cy="13" r="1" fill="currentColor" />
    <circle cx="18" cy="11" r="1" fill="currentColor" />
    <path d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z" />
  </svg>
);

const links = [
  { label: "DISCORD", value: "@aeoneuh", href: "https://discord.com", icon: DiscordIcon },
  { label: "STEAM", value: "aeoneuh", href: "https://steamcommunity.com/profiles/76561198782390625/", icon: SteamIcon },
  { label: "INSTAGRAM", value: "@aeon_dprt", href: "https://www.instagram.com/aeon_dprt/", icon: InstagramIcon },
  { label: "CS2 STATS", value: "Loadout", href: "#loadout", icon: GamepadIcon },
];

export default function Contact() {
  const [callsign, setCallsign] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!callsign.trim() || !message.trim() || sending) return;
    setSending(true);
    setError(false);
    try {
      await axios.post(`${BACKEND_URL}/api/contact`, { callsign, message }, { timeout: 10000 });
      setSent(true);
      setCallsign("");
      setMessage("");
      setTimeout(() => setSent(false), 3200);
    } catch (err) {
      setError(true);
      setTimeout(() => setError(false), 3200);
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="relative px-6 md:px-12 py-24 md:py-32 section-glow section-scan" data-testid="contact-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9 }}
        className="relative z-10 max-w-6xl mb-14"
      >
        <div className="flex items-baseline gap-6 mb-6">
          <span className="font-mono text-sm text-[#F47B20]">CH.03</span>
          <span className="h-px flex-1 bg-gradient-to-r from-[#F47B20]/30 to-white/5 section-line" />
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
            CONTACT / RADIO
          </span>
        </div>
        <h2 className="font-display font-black text-4xl sm:text-5xl md:text-7xl lg:text-8xl uppercase leading-[0.9]">
          Open <span className="text-stroke-orange">Comms</span>
          <br />
          <span className="text-stroke">Channel</span>
        </h2>
        <p className="mt-6 max-w-xl font-mono text-sm text-white/60 leading-relaxed">
          [ 03 ] &nbsp; Send a signal. All messages route through the encrypted
          operative relay.
        </p>
      </motion.div>

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-5">
        {/* Terminal form */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="border border-white/10 bg-black clip-tactical overflow-hidden glow-border"
          data-testid="contact-terminal"
        >
          {/* Terminal header */}
          <div className="flex items-center justify-between px-4 py-3 border-b border-white/10 bg-[#0d0d0f]">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-red-500/80" />
              <span className="w-2.5 h-2.5 rounded-full bg-yellow-400/80" />
              <span className="w-2.5 h-2.5 rounded-full bg-green-400/80" />
            </div>
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
              aeoneuh@op:~$ radio
            </span>
            <span className="font-mono text-[10px] text-[#F47B20] pulse-orange">◈</span>
          </div>

          <form onSubmit={handleSubmit} className="p-6 md:p-8 font-mono text-sm space-y-6">
            <div>
              <label className="block text-[#F47B20] mb-2" htmlFor="callsign">
                &gt; CALLSIGN
              </label>
              <input
                id="callsign"
                value={callsign}
                onChange={(e) => setCallsign(e.target.value)}
                className="w-full bg-transparent border-b border-white/20 focus:border-[#F47B20] outline-none text-white py-3 min-h-[44px] caret-[#F47B20] transition-colors duration-300 placeholder:text-white/20"
                placeholder="[operative alias]"
                data-testid="contact-input-callsign"
                required
              />
            </div>
            <div>
              <label className="block text-[#F47B20] mb-2" htmlFor="message">
                &gt; TRANSMISSION
              </label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows={5}
                className="w-full bg-transparent border border-white/15 focus:border-[#F47B20] outline-none text-white p-3 caret-[#F47B20] resize-none transition-colors duration-300 placeholder:text-white/20"
                placeholder="[begin encrypted message...]"
                data-testid="contact-input-message"
                required
              />
            </div>
            <div className="flex items-center justify-between">
              <button
                type="submit"
                disabled={sending || sent}
                className="group relative border border-[#F47B20] text-[#F47B20] px-6 py-3 min-h-[44px] font-mono text-xs uppercase tracking-[0.25em] hover:bg-[#F47B20] hover:text-black transition-all duration-300 disabled:opacity-60 hover:shadow-[0_0_20px_rgba(244,123,32,0.3)] active:scale-95"
                data-testid="contact-submit"
              >
                {sent ? "// TRANSMITTED" : sending ? "// SENDING..." : error ? "// RETRY" : "// ENGAGE"}
                <span className="ml-2 caret" />
              </button>
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
                {sent ? "SIGNAL_ACK" : error ? "SIGNAL_LOST" : sending ? "TRANSMITTING" : "STDBY"}
              </span>
            </div>
          </form>
        </motion.div>

        {/* Channels */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="border border-white/10 bg-[#0d0d0f] p-6 md:p-8 clip-tactical flex flex-col noise-overlay glow-border"
        >
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-6">
            [ ALT.CHANNELS ]
          </div>
          <ul className="space-y-1">
            {links.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  target={l.href.startsWith("http") ? "_blank" : undefined}
                  rel={l.href.startsWith("http") ? "noopener noreferrer" : undefined}
                  className="flex items-center gap-4 py-4 group border-b border-white/5 last:border-0 min-h-[56px]"
                  data-testid={`contact-link-${l.label.toLowerCase()}`}
                >
                  <span className="text-white/30 group-hover:text-[#F47B20] transition-colors duration-300">
                    <l.icon />
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 group-hover:text-[#F47B20]/60 transition-colors">
                      {l.label}
                    </div>
                    <div className="mt-1 font-display font-bold text-xl text-white group-hover:text-[#F47B20] transition-colors duration-300 truncate">
                      {l.value}
                    </div>
                  </div>
                  <span className="font-mono text-sm text-white/20 group-hover:text-[#F47B20] group-hover:translate-x-1 transition-all duration-300">
                    ↗
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
